import { createI18n } from 'vue-i18n';
/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
    const messages =
        typeof window._HR !== 'undefined' ? window._HR.translations : {};
    return messages;
}
export default createI18n({
    locale:
        typeof window._HR !== 'undefined' ? window._HR.selectedLanguage : 'EN',
    fallbackLocale:
        typeof window._HR !== 'undefined' ? window._HR.selectedLanguage : 'EN',
    messages: loadLocaleMessages(),
});
//# sourceMappingURL=i18n.js.map
